<template>
    <div :class="`HomeJobIndex__item HomeJobIndex__item--${form}`" v-if="loading || jobs.length">

        <div class="HomeJobIndex__item__head" :data-href="url(link)">
            <div class="HomeJobIndex__item__head__title">
                <slot/>
            </div>
            <a :href="url(link)" class="HomeJobIndex__item__head__link">
                <i class="fa fa-plus-square-o"></i>
                <span>další nabídky</span>
            </a>
        </div>

        <div>

            <job-index-item
                v-for="job in jobs"
                :key="job.id"
                :data="job"
            ></job-index-item>

            <div class="JobIndex__empty" v-if="loading">
                <div class="text-center text-gray-light py-5" v-if="loading">
                    <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
export default {

    props: [
        'source',
        'form',
        'link'
    ],

    data() {
        return {
            jobs: [],
            loading: true
        }
    },

    methods: {

        loadDataFromSource() {
            axios.get(url(`/api/jobs?primary-form=${this.form}&limit=2`))
                .then(response => {
                    this.jobs = response.data.data;
                    this.loading = false;
                })
                .catch(errors => {
                });
        }
    },

    mounted() {
        this.loadDataFromSource();
    }
}
</script>
